import {
   NAV_STYLE,
   NAV_STYLE_FIXED,
   NAV_STYLE_FIXED_RIGHT,
   THEME_COLOR,
   THEME_TYPE,
   THEME_TYPE_SEMI_DARK,
   TAB_SIZE
} from "../../constants/ThemeSetting";
import { CP_GAMIFICATION, HOPPY } from "../../constants/GlobalVariables";
import projectConfig from "@projectConfig";

const initialSettings = {
   isNavVisible: !!(window?.self?.innerWidth > TAB_SIZE),
   // For some reason when we use isHoppyOrGamification here, we can get errors sometimes
   navStyle:
      window.location.hostname === CP_GAMIFICATION || window.location.hostname === HOPPY
         ? NAV_STYLE_FIXED_RIGHT
         : NAV_STYLE_FIXED,
   themeType: THEME_TYPE_SEMI_DARK,
   areWidgetSettingsVisible: false,
   themeColor: THEME_COLOR,
   pathname: "/",
   search: "",
   isDirectionRTL: false,

   isNewMessage: false,
   allLanguages: [{ language: "de" }, { language: "en" }, { language: "pl" }, { language: "sp" }],
   plannerSettings: {
      verticalView: true,
      defaultSlots: "00:15:00",
      weekends: false,
      minTime: "08:00:00",
      maxTime: "18:00:01",
      initialView: "timeGridWeek"
   },
   locale: projectConfig?.initialLanguage || "en",
   activeCasesFolder: "inbox"
};

const settings = (state = initialSettings, action) => {
   switch (action.type) {
      case "@@router/LOCATION_CHANGE":
         return {
            ...state,
            pathname: action.payload.location.pathname
         };
      case "SET_IS_NAV_VISIBLE":
         return {
            ...state,
            isNavVisible: action.isNavVisible
         };
      case "SET_IS_NEW_MESSAGE":
         return {
            ...state,
            isNewMessage: action.isNewMessage
         };
      case THEME_TYPE:
         return {
            ...state,
            themeType: action.themeType
         };
      case "ARE_SETTINGS_VISIBLE":
         return {
            ...state,
            areWidgetSettingsVisible: action.areWidgetSettingsVisible
         };
      case THEME_COLOR:
         return {
            ...state,
            themeColor: action.themeColor
         };
      case NAV_STYLE:
         return {
            ...state,
            navStyle: action.navStyle
         };
      case "SWITCH_LANGUAGE":
         document.getElementsByTagName("html")?.[0]?.removeAttribute("lang");
         document
            .getElementsByTagName("html")?.[0]
            ?.setAttribute("lang", action.payload || projectConfig?.initialLanguage);
         return {
            ...state,
            locale: action.payload
         };
      case "SET_SEARCH_PARAMS":
         return {
            ...state,
            search: action.payload
         };
      case "SET_PLANNER_SETTINGS":
         return {
            ...state,
            plannerSettings: action.plannerSettings
         };
      case "SET_ALL_LANGUAGES":
         return {
            ...state,
            allLanguages: action.payload
         };
      case "SET_ACTIVE_CASES_FOLDER": {
         return { ...state, activeCasesFolder: action.payload };
      }
      default:
         return state;
   }
};

export default settings;
